import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { FaSpinner } from "react-icons/fa";
import ReactPaginate from "react-paginate";
import { connect, useDispatch } from "react-redux";
import Select from "react-select";
import { Col, Input, Row, Table } from "reactstrap";
import swal from "sweetalert";
import "../../../css/settings.scss";
import { logout } from "../../../store/actions/AuthActions";
import { api } from "../../../utils/api";
import { exportPageSize, shownItem } from "../../../utils/config";
import { downloadExcel, formatTwoDecimal, truncateToTwoDecimals } from "../../../utils/function";
import { translate } from "../../../utils/translate";
import LoadingV3 from "../../components/Loading/LoadingV3";
import NotFound from "../Common/NotFound";
import customSelectStyles from '../SelectStyle';

const { RangePicker } = DatePicker;

const InvestmentRecord = (props) => {
    const dispatch = useDispatch();
    const [totalResultCount, setTotalResultCount] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [productPerpage, setProductPerpage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [result, setResult] = useState([]);
    const [email, setEmail] = useState('');
    const [mt5Login, setMt5Login] = useState('');
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [firstLoad, setFirstLoad] = useState(true);
    const [loadingExcel, setLoadingExcel] = useState(false);

    const timerRef = useRef(null);

    const changePage = (event) => {
        setPageNumber(event.selected + 1);
        getList(event.selected + 1)
    }

    useEffect(() => {
        getList();
        setFirstLoad(false);
    }, [props.lang]);

    useEffect(() => {
        if (!firstLoad) {
            setPageNumber(1);
            getList(1);
        }
    }, [from, to, productPerpage, email, mt5Login]);

    const handleTimeChange = (e) => {
        const formattedFromDate = e ? dayjs(e[0]).format("YYYY-MM-DD") : '';
        const formattedToDate = e ? dayjs(e[1]).format("YYYY-MM-DD") : '';
        setFrom(formattedFromDate);
        setTo(formattedToDate);
    }

    const getList = (page = pageNumber) => {
        setLoading(true);
        let url = api.get_mt5_deal_details + `?page=${page}`;
        if (productPerpage) {
            url += `&limit=${productPerpage}`
        }
        if (from && to) {
            url += `&date_start=${from}&date_end=${to}`
        }
        if (email) {
            url += `&email=${email}`
        }
        if (mt5Login) {
            url += `&mt5_login=${mt5Login}`
        }
        fetch(url, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoading(false);
                }, 1000);
                if (responseJson.status === "success") {
                    setResult(responseJson.data.results);
                    var pageCount = Math.ceil(responseJson.data.total_results / productPerpage)
                    setPageCount(pageCount);
                    setTotalResultCount(responseJson.data.total_results)
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log("error", responseJson.message);
                }

            }).catch(error => {
                console.error("error", error);
            });
    }

    const formatData = (data) => {
        let newData = [];
        data.forEach(entry => {
            let formattedData = {
                "Date": entry.date_added ? entry.date_added : '-',
                "Email": entry.email ? entry.email : '-',
                "Name": entry.full_name ? entry.full_name : entry.nick_name,
                "Order ID": entry.order ? entry.order : '-',
                "Trading Pair": entry.symbol ? entry.symbol : '-',
                "Lot Size": entry.volume ? entry.volume : '-',
                "Price Enter": entry.price_position ? formatTwoDecimal(entry.price_position) : '-',
                "Price Close": entry.price ? formatTwoDecimal(entry.price) : '-',
                "Action": entry.action_type ? entry.action_type : '-',
                "Profit/Loss %": entry.profit ? formatTwoDecimal(entry.profit) : '-',
                "Status": entry.status ? entry.status : '-',
            };
            newData.push(formattedData);
        });
        return newData;
    }

    const exportExcel = () => {
        const totalPagesCount = Math.ceil(totalResultCount / exportPageSize);
        let processData = [];
        let totaldata = 0;
        if (totalPagesCount > 0) {
            setLoadingExcel(true);
            for (let pageCount = 1; pageCount <= totalPagesCount; pageCount++) {
                let url = api.get_mt5_deal_details + `?page=${pageCount}&limit=${exportPageSize}`;

                if (from && to) {
                    url += `&date_start=${from}&date_end=${to}`
                }
                if (email) {
                    url += `&email=${email}`
                }
                if (mt5Login) {
                    url += `&mt5_login=${mt5Login}`
                }

                fetch(url, {
                    method: "GET",
                    headers: new Headers({
                        "Content-Type": "application/json",
                        "Accept-Language": props.lang,
                        "Authorization": "Bearer " + props.auth.auth.access_token
                    }),
                })
                    .then(response => response.json())
                    .then(responseJson => {
                        if (responseJson.status === "success") {
                            totaldata = responseJson.data.total_results;
                            processData = processData.concat(formatData(responseJson.data.results));
                        } else {
                            if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                                dispatch(logout(props.history, 'login'));
                            }
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                        if (processData.length === totaldata) {
                            downloadExcel(processData, 'investment_record')
                            setLoadingExcel(false)
                        }
                    }).catch(error => {
                        console.error("error", error);
                    });
            }
        } else {
            swal(translate(props.lang, "Error"), translate(props.lang, "No data to export"), "error");
        }
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="whiteContainer px-md-4 py-md-4 p-2">
                            <div className="tableContainer">
                                <Row className="align-items-center mt-3">
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Enter Member Email")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setEmail(e.target.value)}
                                                    value={email}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="groupLabel-input">
                                            <div className="input-group">
                                                <Input
                                                    type="text"
                                                    placeholder={translate(props.lang, "Enter Member MT5 Login")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    onChange={e => setMt5Login(e.target.value)}
                                                    value={mt5Login}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <RangePicker
                                            className="w-100 input-transparent"
                                            placeholder={[
                                                translate(props.lang, "From"),
                                                translate(props.lang, "To"),
                                            ]}
                                            onChange={(e) => handleTimeChange(e)}
                                        />
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <div className="input-group-select select-placeholder-center">
                                            <Select
                                                options={
                                                    shownItem.length > 0 ? shownItem.map((item, i) => ({ key: i, value: item.value, label: item.label })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                }
                                                placeholder={translate(props.lang, "Result Per Page")}
                                                className="input-transparent w-100 text-capitalize"
                                                styles={customSelectStyles}
                                                isSearchable={false}
                                                value={shownItem && shownItem.find(option => option.value === productPerpage)}
                                                name="productPerpage"
                                                onChange={(e) => setProductPerpage(e.value ? e.value : '')}
                                            />
                                        </div>
                                    </Col>
                                    <Col lg={4} md={4} sm={12} xs={12} className="mb-3">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => exportExcel()}>
                                            <span className={`btnText`}>{loadingExcel ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Download Excel")}</span>
                                        </button>
                                    </Col>
                                </Row>
                                <Table responsive className="w-100 table-list text-center position-relative">
                                    <thead>
                                        <tr>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Date")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Email")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Name")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Order ID")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Trading Pair")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Lot Size")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Price Enter")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Price Close")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Action")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit/Loss %")}</th>
                                            <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan={11}>
                                                    <LoadingV3 theme='light' />
                                                </td>
                                            </tr>
                                        ) : (
                                            result.length > 0 ? (
                                                result.map((item, i) => (
                                                    <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`} key={i}>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.date_added ? item.date_added : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.email ? item.email : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.full_name ? item.full_name : item.nick_name}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.order ? item.order : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.symbol ? item.symbol : '-'}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.volume ? item.volume : '-'}</td>
                                                        {/* <td className={`font-weight-500 font-16 text-center`}>{item.price_position ? formatTwoDecimal(item.price_position) : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.price ? formatTwoDecimal(item.price) : 0}</td> */}
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.price_position ? item.price_position : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center`}>{item.price ? item.price : 0}</td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize status`}>{item.action_type}</td>
                                                        <td>
                                                            <span className={`font-weight-500 font-16 text-center text-capitalize ${item.profit ? item.profit < 0 ? "status failed" : item.profit > 0 ? "status active" : '' : ''}`}>{item.profit ? truncateToTwoDecimals(item.profit) : 0}</span>
                                                        </td>
                                                        <td className={`font-weight-500 font-16 text-center text-capitalize status ${item.status.toLowerCase()}`}>{item.status.toLowerCase() === 'active' ? translate(props.lang, "completed") : translate(props.lang, item.status.toLowerCase())}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr role="row" className={`even`}>
                                                    <td colSpan={11}>
                                                        <NotFound />
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                    </tbody>
                                </Table>
                            </div>
                            <div className="pt-4">
                                {!loading && result.length > 0 ? (
                                    <div className="my-3">
                                        <ReactPaginate
                                            previousLabel={"<"}
                                            nextLabel={">"}
                                            pageCount={pageCount}
                                            forcePage={pageNumber - 1}
                                            onPageChange={changePage}
                                            containerClassName={"pagination font-weight-400 font-16 text-uppercase text-grey-2"}
                                            previousLinkClassName={"pagination__previouslink pagination-arrow"}
                                            nextLinkClassName={"pagination__nextlink pagination-arrow"}
                                            disabledClassName={"pagination__link--disabled text-muted"}
                                            activeClassName={"pagination__link--active text-black"}
                                            marginPagesDisplayed={window.innerWidth > 667 ? 3 : 1}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(InvestmentRecord);